/**
 * Formatting shared by the Agents screens: relative time, durations, dates.
 * (Was copied into the list, runs and version panels.)
 */

/** "5m ago", "3d ago"; '' for a missing or invalid date. */
export function timeAgo(value, now = Date.now()) {
  if (value == null || value === '') return '';
  const t = new Date(value).getTime();
  if (Number.isNaN(t)) return '';
  const secs = Math.max(0, Math.floor((now - t) / 1000));
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  const weeks = Math.floor(days / 7);
  if (weeks < 5) return `${weeks}w ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.floor(days / 365)}y ago`;
}

/** Human duration for a step or run; '' when there is none. */
export function formatExecDuration(ms) {
  if (typeof ms !== 'number' || Number.isNaN(ms)) return '';
  if (ms < 1000) return `${ms}ms`;
  if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
  return `${Math.floor(ms / 60000)}m ${Math.round((ms % 60000) / 1000)}s`;
}

/** Same, with a placeholder for tables ('—' by default). */
export function formatDuration(ms, empty = '—') {
  return formatExecDuration(ms) || empty;
}

/** "Oct 2, 2026, 3:04 PM" in the viewer's locale; '' when invalid. */
export function formatDate(value) {
  if (value == null || value === '') return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}
